import { render, staticRenderFns } from "./LammieHome.vue?vue&type=template&id=4985309a"
import script from "./LammieHome.vue?vue&type=script&lang=js"
export * from "./LammieHome.vue?vue&type=script&lang=js"
import style0 from "./LammieHome.vue?vue&type=style&index=0&id=4985309a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4985309a')) {
      api.createRecord('4985309a', component.options)
    } else {
      api.reload('4985309a', component.options)
    }
    module.hot.accept("./LammieHome.vue?vue&type=template&id=4985309a", function () {
      api.rerender('4985309a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/lammie/LammieHome.vue"
export default component.exports